export enum TipoRegistro {
    Invalid,
    Pago,
    Liquidacion
}